var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "verified ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    rx: 9.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Public-GTIN-Query---complete-basic-attributes",
    transform: "translate(-236.000000, -783.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verified-",
    transform: "translate(236.000000, 783.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7AC144",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -25.321596)",
    id: "Mask"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#7AC144",
    fillRule: "nonzero",
    x: 0,
    y: 25.3215965,
    width: 60,
    height: 60
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "31.9235771 54.9344803 29.4448335 64.153246 12.7178153 44.1612484 17.2191657 37.3552066"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 1.788,
    points: "31.9235771 54.9344803 29.4448335 64.153246 12.7178153 44.1612484 17.2191657 37.3552066"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "29.4448335 64.153246 25.9157747 54.9584875 59.6458938 0 66.3078924 4.08722617"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 1.788,
    points: "29.4448335 64.153246 25.9157747 54.9584875 59.6458938 0 66.3078924 4.08722617"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#002D6C",
    fillRule: "nonzero",
    x: 0,
    y: 57.4252276,
    width: 60,
    height: 27.8963689
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96438932,72.0096029 L7.96438932,71.7935381 C7.96438932,66.8360508 11.2473742,63.2649795 15.796739,63.2649795 C17.8091461,63.192544 19.7726367,63.8950182 21.2823847,65.2275683 L19.2057617,67.9343803 C18.2905355,67.0037775 17.0358869,66.4858828 15.7307192,66.49995 C13.329999,66.49995 11.5294588,68.6786036 11.5294588,71.7695309 L11.5294588,71.9615885 C11.5294588,75.4126238 13.420026,77.363209 15.886766,77.363209 C16.769567,77.3988127 17.641124,77.1551967 18.3775133,76.6670001 L18.3775133,73.6660998 L15.3406022,73.6660998 L15.3406022,70.6651996 L21.6905072,70.6651996 L21.6905072,78.4315295 C19.9917026,79.7779741 17.8923185,80.5193059 15.7247174,80.5381614 C11.223367,80.5381614 7.96438932,77.2791838 7.96438932,72.0336101",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8077423,78.023407 L27.8663599,75.4606382 C28.9946984,76.4389317 30.3571071,77.3512054 32.0676203,77.3512054 C33.4060218,77.3512054 34.2222667,76.6790037 34.2222667,75.7007102 L34.2222667,75.7007102 C34.2222667,74.8604581 33.7421226,74.3322997 31.3474042,73.420026 C28.376513,72.2736821 26.5459638,71.1453436 26.5459638,68.2704811 L26.5459638,68.2224667 C26.5459638,65.2995899 28.796639,63.312831 32.0316095,63.312831 C34.0261071,63.3002572 35.9531133,64.0346606 37.43323,65.3716115 L35.4946484,68.0064019 C34.5064287,67.0931336 33.2359647,66.5447166 31.8935681,66.4519356 C30.693208,66.4519356 29.9549865,67.0521156 29.9549865,67.9103731 L29.9549865,67.9103731 C29.9549865,68.8706612 30.5251575,69.326798 33.1419426,70.4011203 C36.0648194,71.553466 37.643293,72.8018406 37.643293,75.4126238 L37.643293,75.4606382 C37.643293,78.5755727 35.2725818,80.4901591 32.0136041,80.4901591 C29.7052381,80.4939263 27.4836152,79.6108634 25.8077423,78.023407",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "42.3847154 80.2740822 42.3847154 77.4712414 46.219866 77.4712414 46.219866 66.9560868 42.7928379 68.3184955 42.1926578 65.3476043 47.2221666 63.3850155 49.5448635 63.3850155 49.5448635 77.4712414 52.89987 77.4712414 52.89987 80.2740822"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedBarcode);
export default __webpack_public_path__ + "static/media/verified-barcode.b91c8c4d9f74401e46212b0417e82217.svg";
export { ForwardRef as ReactComponent };